export const userQueryKeys = {
  id: 'id',
  fullName: 'user_name',
  firstname: 'name',
  lastname: 'surname',
  branch: {
    id: 'branch_id',
    name: 'branch_name',
  },
  email: 'email',
  phoneNumber: 'number',
  balance: {
    usd: 'balance_usd',
    try: 'balance_try',
  },
  adminCompanyName: 'admin_company_name',
  birthDate: 'birth_date',
  gender: 'gender',
  passport: {
    number: 'passport_number',
    secret: 'passport_secret',
  },
  blocked: 'blocked',
  role: 'admin',
  declarations: {
    state: {
      id: 'declaration_state_id',
    },
  },
  mobileAppUser: 'mobile_app_user',
};
